import { render, staticRenderFns } from "./BranchStudentsSystemChartProgress.vue?vue&type=template&id=bf0d4fdc&scoped=true&lang=pug&"
import script from "./BranchStudentsSystemChartProgress.vue?vue&type=script&lang=ts&"
export * from "./BranchStudentsSystemChartProgress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0d4fdc",
  null
  
)

export default component.exports